<template>
  <div class="contact-form">
    <div :class="!nopadding ? 'container' : ''">
      <div :class="!nopadding ? 'd-flex' : ''">
        <div :class="!nopadding ? 'col-12' : ''">
          <div :class="!nopadding ? 'card' : ''">
            <div :class="!nopadding ? 'card-body' : ''">
              <div :class="!nopadding ? 'd-flex justify-content-center' : ''">
                <div :class="!nopadding ? 'col-12 col-md-6' : ''">
                  <form @submit.prevent="submit_form">
                    <div class="contact-form-title" v-if="!nopadding">
                      {{ $t("message.atb_home.contact_form_title") }}
                    </div>
                    <div class="form-group">
                      <label for="subject">{{
                        $t("message.atb_home.contact_form_subject")
                      }}</label
                      ><input
                        id="subject"
                        v-model="subject"
                        required
                        type="text"
                        :placeholder="
                          $t(
                            'message.atb_home.contact_form_subject_placeholder',
                          )
                        "
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label for="name">{{
                        $t("message.atb_home.contact_form_name")
                      }}</label
                      ><input
                        id="name"
                        v-model="name"
                        required
                        type="text"
                        :placeholder="
                          $t('message.atb_home.contact_form_name_placeholder')
                        "
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label for="email">{{
                        $t("message.atb_home.contact_form_email")
                      }}</label
                      ><input
                        id="email"
                        v-model="email"
                        required
                        type="email"
                        :placeholder="
                          $t('message.atb_home.contact_form_email_placeholder')
                        "
                        class="form-control"
                      />
                    </div>
                    <div class="form-group textarea">
                      <label for="message">{{
                        $t("message.atb_home.contact_form_message")
                      }}</label
                      ><input
                        id="message"
                        v-model="message"
                        :placeholder="
                          $t(
                            'message.atb_home.contact_form_message_placeholder',
                          )
                        "
                        required
                        type="text"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group checkbox">
                      <label
                        ><input
                          type="checkbox"
                          class="form-control"
                          v-model="i_accept"
                        /><span></span>
                        {{ $t("message.atb_home.contact_form_accept") }}</label
                      >
                    </div>
                    <div :class="!nopadding ? 'form-group button' : 'button'">
                      <div
                        class="alert alert-success rounded mb-2"
                        v-if="show_thankyou"
                      >
                        {{ $t("message.message_sent") }}
                      </div>
                      <button
                        class="btn btn-primary btn-lg d-block w-100"
                        :disabled="!i_accept || show_thankyou || sending"
                      >
                        <span v-if="!show_thankyou && !sending">{{
                          $t("message.atb_home.contact_form_submit")
                        }}</span>
                        <span v-if="show_thankyou">{{
                          $t("message.atb_home.contact_form_submit_success")
                        }}</span>
                        <span v-if="sending">{{
                          $t("message.atb_home.contact_form_submit_sending")
                        }}</span>
                        <i class="fa fa-chevron-right ml-2"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    nopadding: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: "",
      email: "",
      subject: "",
      message: "",
      i_accept: false,

      show_thankyou: false,
      submitted: false,
      sending: false,
    };
  },
  methods: {
    submit_form() {
      this.sending = true;
      let fd = new FormData();
      fd.append("name", this.name);
      fd.append("email", this.email);
      fd.append("subject", this.subject);
      fd.append("message", this.message);
      axios
        .post(window.base + "/home/SendEmail", fd)
        .then((response) => {
          this.show_thankyou = true;
          this.sending = false;
          this.name = "";
          this.email = "";
          this.subject = "";
          this.message = "";
          this.i_accept = false;
          setTimeout(() => {
            this.show_thankyou = false;
          }, 4000);
        })
        .catch(() => {
          this.show_thankyou = true;
          this.sending = false;
          this.name = "";
          this.email = "";
          this.subject = "";
          this.message = "";
          setTimeout(() => {
            this.show_thankyou = false;
          }, 10000);
        });
    },
  },
};
</script>
<style scoped>
.contact-form-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 44px;
  line-height: 56px;
  /* identical to box height, or 127% */

  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 80px;
  justify-content: center;

  /* attis/primary */

  color: #04416d;
}
.form-group {
  position: relative;
  margin-top: 20px;
  margin-bottom: 36px;
  height: 56px;
}

.form-group.textarea {
  height: 112px;
}
.form-group .form-control {
  border: 0;
  height: 50px;
  position: absolute;
  box-shadow: none !important;
  outline: none !important;
  border: 1px solid #b1b1b1;
  border-radius: 4px;
  height: 56px;
}

.form-group .form-control:hover {
  border-color: #333333;
}
.form-group .form-control:focus {
  border-color: var(--color2);
}
.form-group textarea.form-control {
  height: 104px;
}
.form-group label {
  font-family: "Roboto";
  padding: 0 4px;
  background-color: #fff;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  position: absolute;
  left: 16px;
  z-index: 3;
  top: -8px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
  cursor: default !important;
}
.form-group.checkbox {
  border: 0;

  justify-content: flex-starts;
}
.form-group.checkbox input {
  position: relative;
  height: 24px;
  width: 24px;
  margin-right: 15px;
}
.form-group.checkbox label {
  position: relative;
  display: flex;
  left: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  display: flex;
  align-items: start;

  /* neutral/10 */

  color: #333333;
}
.form-group.button {
  border: 0;
  margin-bottom: 80px;
}
.form-group.button button svg,
.form-group.button button i {
  margin-left: 15px;
}
.btn.btn-primary {
  transition: none !important;
}
.btn.btn-primary:hover {
  background: var(--color1) !important;
  box-shadow: none !important;
  color: #fff !important;
}
.form-group.checkbox input {
  opacity: 0;
  position: absolute;
}
.form-group.checkbox span {
  width: 20px;
  flex-basis: 20px;
  min-width: 20px;
  max-width: 20px;
  margin-right: 14px;
  height: 20px;
  border: 2px solid #797980;
  border-radius: 3px;
}
.form-group.checkbox label:hover span {
  border-color: var(--color1);
}
.form-group.checkbox label input:checked + span {
  /* background-color: var(--color1); */
  border-color: var(--color1);
  position: relative;
}
.form-group.checkbox label input:checked + span:before {
  content: "";
  width: 20px;
  height: 20px;
  display: block;
  position: absolute;
  left: -2px;
  top: -2px;
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.7778 0H2.22222C0.988889 0 0 1 0 2.22222V17.7778C0 19 0.988889 20 2.22222 20H17.7778C19.0111 20 20 19 20 17.7778V2.22222C20 1 19.0111 0 17.7778 0ZM7.77778 15.5556L2.22222 10L3.78889 8.43333L7.77778 12.4111L16.2111 3.97778L17.7778 5.55556L7.77778 15.5556Z' fill='%23097CB1'/%3E%3C/svg%3E");
}
</style>
